import {
	OrderByEnum,
	ProductRequestDto,
	RequestParams,
	restRepository,
} from "@onair/repositories";

export interface GetTopProductsInput {
	limit?: string;
}

export const getTopProducts = async (input: GetTopProductsInput) => {
	const response = await restRepository.api.getTopProducts(input);
	return response.data;
};

export interface IGetProductViewsParams {
	search?: string;
	ids?: string[];
	statuses?: string[];
	excludes?: string[];
	types?: string[];
	isAcademy?: boolean;
	offset?: number;
	limit?: number;
	startDate?: string;
	endDate?: string;
	ownerId?: string;
	notExpired?: boolean;
	isFree?: boolean;
	isReskill?: boolean;
	isLaunchpad?: boolean;
	locationType?: string;
	username?: string;
	orderField?: string;
	order?: OrderByEnum;
	cursor?: string;
}

const formatParamProductViews = (params: IGetProductViewsParams) => {
	return {
		search: params.search || "",
		ids: (params.ids || []).length ? params.ids?.join(",") : undefined,
		statuses: (params.statuses || []).length
			? params.statuses?.join(",")
			: undefined,
		excludes: (params.excludes || []).length
			? params.excludes?.join(",")
			: undefined,
		types: (params.types || []).length ? params.types?.join(",") : undefined,
		isAcademy: params?.isAcademy,
		isReskill: params?.isReskill,
		isLaunchpad: params?.isLaunchpad,
		offset: params.offset || 1,
		limit: params.limit || 10,
		startDate: params.startDate ? params.startDate : undefined,
		endDate: params.endDate ? params.endDate : undefined,
		notExpired: params?.notExpired || false,
		ownerId: params?.ownerId || undefined,
		isFree: typeof params?.isFree === "boolean" ? params.isFree : undefined,
		locationType: params?.locationType || undefined,
		orderField: params.orderField || undefined,
		order: params.order || undefined,
		username: params.username || undefined,
		cursor: params.cursor,
	};
};

export const getProductViews = async (params: IGetProductViewsParams) => {
	const response = await restRepository.api.getProductViews(
		formatParamProductViews(params),
	);
	return response.data;
};

export const getContentAndProducts = async (params: IGetProductViewsParams) => {
	const response = await restRepository.api.getContentAndProducts(
		formatParamProductViews(params),
	);
	return response.data;
};

export const getEligibleProductViews = async (
	params: IGetProductViewsParams,
) => {
	const response = await restRepository.api.getEligibleProductViews(
		formatParamProductViews(params),
	);
	return response.data;
};

export const getAccessibleProduct = async (productId: string) => {
	const response = await restRepository.api.getAccessibleProduct(productId);
	return response.data;
};

export const updateProduct = async (
	productId: string,
	data: ProductRequestDto,
) => {
	const response = await restRepository.api.updateProduct(productId, data);
	return response.data;
};

export const getProductSurveys = async (
	productId: string,
	params?: RequestParams,
) => {
	const response = await restRepository.api.getProductSurveys(
		productId,
		params,
	);
	return response.data;
};
